import { objectKeys, formatKebabCase } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import { getAllCloudEmulationOptions, CloudEmulationOption, getDeveloperEnvironmentOption, DeveloperEnvironmentOption } from '../AdvancedSettings/devSettings.js';
import __vue_component__ from '../../../ui/Tooltip/Tooltip.vue.js';
import '@caresend/types';
import 'firebase/auth';
import '../../../../database/firebaseConfig/cloudFunctions.js';
import { isProdDeployment } from '../../../../database/firebaseConfig/init.js';
import '../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import '../../../../router/helpers/initRouter.js';
import { getStore } from '../../../../store/helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { advancedSettingsRoute } from '../../../../router/routes/dev/locations.js';

var script = defineComponent({
    name: 'AdvancedSettingsButton',
    components: {
        Tooltip: __vue_component__,
    },
    props: {
        /** Disable the route if using in storybook */
        disableRoute: Boolean,
        prodDemo: Boolean,
    },
    setup(props) {
        const store = getStore();
        const isProdMode = computed(() => props.prodDemo || isProdDeployment);
        const featureFlagOverridesCount = computed(() => objectKeys(store.state.variables.featureFlagOverrides).length);
        const showComponent = computed(() => {
            if (!isProdMode.value)
                return true;
            return featureFlagOverridesCount.value > 0;
        });
        const tag = computed(() => props.disableRoute ? undefined : 'router-link');
        const to = computed(() => props.disableRoute ? undefined : advancedSettingsRoute());
        const localEnabled = Object.values(getAllCloudEmulationOptions())
            .some((option) => option === CloudEmulationOption.LOCAL);
        const currentEnvironment = formatKebabCase(getDeveloperEnvironmentOption());
        const currentEmulationOption = formatKebabCase(localEnabled
            ? CloudEmulationOption.LOCAL
            : CloudEmulationOption.CLOUD);
        const environmentTooltip = computed(() => {
            const lines = [];
            if (!isProdMode.value) {
                // TODO: Handle case of partial local env (ex: Local db, cloud functions)
                lines.push(`Environment: ${currentEnvironment.split(' ')[0]}`);
                lines.push(`DB/Functions: ${currentEmulationOption}`);
            }
            if (featureFlagOverridesCount.value) {
                lines.push(`Feature flag overrides: ${featureFlagOverridesCount.value}`);
            }
            return lines.join('\n');
        });
        const environmentIcon = getDeveloperEnvironmentOption() === DeveloperEnvironmentOption.DEVELOPMENT
            ? 'drafting-compass' : 'globe-americas';
        const emulationIcon = localEnabled
            ? 'desktop' : 'cloud';
        return {
            emulationIcon,
            environmentIcon,
            environmentTooltip,
            featureFlagOverridesCount,
            isProdMode,
            showComponent,
            tag,
            to,
        };
    },
});

export { script as default };
